<template>
  <div class="col-12 row">
    <div class="col-12 text-h6 text-left">
      {{ sessionNoteField.label }}
    </div>
    <div
      v-if="sessionNoteField.hint"
      class="col-12 text-subtitle1 text-left q-py-md"
    >
      {{ sessionNoteField.hint }}
    </div>
    <div class="col-12">
      <div
        v-if="isLoading"
        class="row q-col-gutter-sm q-mt-md"
      >
        <div
          v-for="n in 5"
          :key="n"
          class="row col-12 items-center"
        >
          <div class="col-auto q-mr-md">
            <q-skeleton
              type="QCheckbox"
            />
          </div>
          <div>
            <q-skeleton
              type="text"
              width="250px"
            />
          </div>
        </div>
      </div>
      <div
        v-else
        class="text-left q-mt-md"
      >
        <q-checkbox
          v-model="selectAll"
          :label="$t('sessions.noteTemplate.programsLabel')"
          :disable="disabledFields"
          class="text-bold"
        />
        <q-option-group
          :model-value="formatSelectValue(sessionNoteField.value)"
          type="checkbox"
          :options="options"
          :disable="disabledFields"
          class="text-left"
          @update:model-value="onSelectOption"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { chain, isArray, isEmpty, map } from 'lodash';
import Toolbox from 'src/mixins/Toolbox';

export default {
  name: 'SessionNoteDataSectionForm',

  mixins: [Toolbox],

  props: {
    sessionNoteField: {
      type: Object,
      required: true,
    },
    session: {
      type: Object,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    disabledFields: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['select-option'],

  data() {
    return {
      isLoading: false,
      selectedPrograms: [],
    };
  },

  computed: {

    selectAll: {
      get() {
        const selectedValues = this.formatSelectValue(this.sessionNoteField.value);
        if (isEmpty(selectedValues)) {
          return false;
        }
        if (chain(this.options)
          .map('value')
          .xor(selectedValues)
          .isEmpty()
          .value()) {
          return true;
        }

        return null;
      },
      set(selectAll) {
        if (selectAll) {
          this.$emit('select-option', map(this.options, 'value'));
        } else {
          this.$emit('select-option', []);
        }
      },
    },
  },

  mounted() {
    this.preparePrograms();
  },

  methods: {

    onSelectOption(selectedOptions) {
      this.$emit('select-option', selectedOptions);
    }, // onSelectOption()

    async preparePrograms() {
      this.isLoading = true;
      try {
        if (isEmpty(this.formatSelectValue(this.sessionNoteField.value))) {
          this.$emit('select-option', chain(this.programOptions).filter('hasData').map('value').value());
        }
      } finally {
        this.isLoading = false;
      }
    },

    formatSelectValue(value) {
      return isArray(value) ? value : [];
    }, // formatSelectOptions()

  },
};
</script>
